<template>
  <q-btn-dropdown icon="fa fa-info-circle" :label="label" rounded flat>
    <q-list>
      <q-item
        v-for="resourceGroup in resourceGroups"
        :key="resourceGroup.label"
        clickable
        v-close-popup
        @click="openModal(resourceGroup)"
      >
        <q-item-section side>
          <q-icon :name="resourceGroup.icon" />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ resourceGroup.label }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { ResourceGroup, resourceGroups } from '.';
import ResourcesModal from './ResourcesModal.vue';

interface Data {
  resourceGroups: ResourceGroup[]
}

export default defineComponent({
  data(): Data {
    return {
      resourceGroups,
    };
  },
  computed: {
    label(): string|undefined {
      return (this.$q.screen.gt.sm) ? 'Resources' : undefined;
    },
  },
  methods: {
    openModal(resourceGroup: ResourceGroup) {
      openModal(ResourcesModal, { parent: this, resourceGroup });
    },
  },
});
</script>
